function isPlainObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export function deepMerge(target, ...sources) {
  const output = { ...target };

  sources.forEach((source) => {
    if (!isPlainObject(source)) return;

    Object.keys(source).forEach((key) => {
      if (isPlainObject(source[key]) && isPlainObject(output[key])) {
        output[key] = deepMerge(output[key], source[key]);
      } else {
        output[key] = source[key];
      }
    });
  });

  return output;
}
